import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const LandingHeader = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const currentPath = location.pathname;

  const isActive = (path) => {
    if (path === "/") {
      return currentPath === "/" ? " active" : "";
    }
    return currentPath === path || currentPath.startsWith(path + "/") || (path === "/events" && currentPath.startsWith("/event/"))
      ? " active"
      : "";
  };

  const toggleMobile = () => setMobileOpen(!mobileOpen);
  const closeMobile = () => setMobileOpen(false);

  return (
    <header className="site-header">
      <Link to="/" className="brand" aria-label="Rebel home" onClick={closeMobile}>
        <img src="/assets/rebel-logo.png" alt="Rebel" />
      </Link>

      <button
        className="menu-toggle"
        type="button"
        aria-label="Open navigation"
        aria-expanded={mobileOpen}
        aria-controls="main-navigation"
        onClick={toggleMobile}
      >
        ☰
      </button>

      <nav className={`main-nav ${mobileOpen ? "open" : ""}`} id="main-navigation">
        <Link className={isActive("/")} to="/" onClick={closeMobile}>
          Home
        </Link>
        <Link className={isActive("/howitworks")} to="/howitworks" onClick={closeMobile}>
          How It Works
        </Link>
        <Link className={isActive("/about")} to="/about" onClick={closeMobile}>
          About Us
        </Link>
        <Link className={`events-nav-link ${isActive("/events")}`} to="/events" onClick={closeMobile}>
          Events
        </Link>
        <Link className={isActive("/creators")} to="/creators" onClick={closeMobile}>
          Creators
        </Link>
        <Link className={isActive("/subscriber")} to="/subscriber" onClick={closeMobile}>
          Subscriber FAQ
        </Link>
        <Link className={isActive("/creator")} to="/creator" onClick={closeMobile}>
          Creator FAQ
        </Link>

        <div className="mobile-account-actions">
          <Link to="/signin" className="button btn button-outline btn-outline btn-small" onClick={closeMobile}>
            Sign In
          </Link>
          <Link to="/signup" className="button btn button-gradient btn-gradient btn-small" onClick={closeMobile}>
            Sign Up
          </Link>
        </div>
      </nav>

      <div className="account-actions">
        <Link to="/signin" className="button btn button-outline btn-outline btn-small">
          Sign In
        </Link>
        <Link to="/signup" className="button btn button-gradient btn-gradient btn-small">
          Sign Up
        </Link>
      </div>
    </header>
  );
};

export default LandingHeader;
